import React from 'react'
import moment from 'moment'
import './Pro.css'

const Pro = ({ data }) => {
    const { availabilities, firstname, lastname, title, email, phone, gmail, createdAt, updatedAt,...rest } = data
    const { days } = availabilities[0]
    const { mo, tu, we, th, fr, sa, su } = days
    return <table className="table table--pro">
        <tbody>
            <tr>
                <th>Created</th>
                <td>{moment(createdAt).format('DD.MM.YYYY HH:mm:ss')}</td>
            </tr>
            <tr>
                <th>Updated</th>
                <td>{moment(updatedAt).format('DD.MM.YYYY HH:mm:ss')}</td>
            </tr>
            <tr>
                <th>First name</th>
                <td>{firstname}</td>
            </tr>
            <tr>
                <th>Last name</th>
                <td>{lastname}</td>
            </tr>
            <tr>
                <th>Title</th>
                <td>{title}</td>
            </tr>
            <tr>
                <th>Email</th>
                <td>{email}</td>
            </tr>
            <tr>
                <th>Gmail</th>
                <td>{gmail}</td>
            </tr>
            <tr>
                <th>Phone</th>
                <td>{phone}</td>
            </tr>
            {
                Object.keys(rest).map(k => <tr key={k}><th scope="row">{k}</th><td>{data[k]}</td></tr>)
            }
            <tr>
                <th valign="top" scope="row">Availabilities</th>
                <td>
                    <table className="table table--availabilities">
                        <tbody>
                            <tr>
                                <td>Monday:</td>
                                <td>{`${mo.time[0][0]} - ${mo.time[0][1]}`}</td>
                            </tr>
                            <tr>
                                <td>Tuesday:</td>
                                <td>{`${tu.time[0][0]} - ${tu.time[0][1]}`}</td>
                            </tr>
                            <tr>
                                <td>Wednesday:</td>
                                <td>{`${we.time[0][0]} - ${we.time[0][1]}`}</td>
                            </tr>
                            <tr>
                                <td>Thursday:</td>
                                <td>{`${th.time[0][0]} - ${th.time[0][1]}`}</td>
                            </tr>
                            <tr>
                                <td>Friday:</td>
                                <td>{`${fr.time[0][0]} - ${fr.time[0][1]}`}</td>
                            </tr>
                            <tr>
                                <td>Saturday:</td>
                                <td>{`${sa.time[0][0]} - ${sa.time[0][1]}`}</td>
                            </tr>
                            <tr>
                                <td>Sunday:</td>
                                <td>{`${su.time[0][0]} - ${su.time[0][1]}`}</td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>

        </tbody>
    </table>
}

export default Pro


// WEBPACK FOOTER //
// ./src/components/Pro/Pro.js